// SuccessPopup.tsx
import React from 'react';
import { Dialog, DialogContent, Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface SuccessPopupProps {
    open: boolean;
    onClose: () => void;
    message: string;
}

const SuccessPopup: React.FC<SuccessPopupProps> = ({ open, onClose, message }) => {
    return (
        <Dialog open={open} onClose={onClose} sx={{ position: "absolute", right: "0px;", top: "-300px", left: "auto" }}>
            <DialogContent
                sx={{
                    backgroundColor: '#F4FFF5',
                    display: 'flex',
                    alignItems: 'end',
                    gap: 2,
                    border: '1px solid #6ACF7D',
                    borderRadius: '12px',
                    padding: '16px 24px',
                }}
            >
                <CheckCircleIcon sx={{ color: '#00A323', fontSize: 40 }} />
                <Typography sx={{ color: '#00A323', fontWeight: 600 }}>
                    {message}
                </Typography>
            </DialogContent>
        </Dialog>
    );
};

export default SuccessPopup;


